import { render, staticRenderFns } from "./EBelgeButon.vue?vue&type=template&id=a8883b84&"
import script from "./EBelgeButon.vue?vue&type=script&lang=js&"
export * from "./EBelgeButon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports